import { render, staticRenderFns } from "./TurningStool.vue?vue&type=template&id=cfc7cfcc&"
import script from "./TurningStool.vue?vue&type=script&lang=js&"
export * from "./TurningStool.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports